/* eslint-disable @typescript-eslint/no-explicit-any */

type FnTarget<A, AR extends any[], R = any> = (a: A, ...rest: AR) => R;
type FnTransform<S, T> = (s: S) => T;

export const transformFirstArgument =
    <S, ST, A extends any[], R = any>(targetFn: FnTarget<ST, A, R>, transformFn: FnTransform<S, ST>) =>
    (first: S, ...args: A) =>
        targetFn(transformFn(first), ...args);
